import { inputAnatomy as parts } from "@chakra-ui/anatomy"
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system"

import merge from "lodash/merge"

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys)

import type { StyleFunctionProps } from "@chakra-ui/styled-system"
import { theme } from "@chakra-ui/theme"

const variantOutline = definePartsStyle((props: StyleFunctionProps) => {
  const defaultStyles =
    theme.components?.Input?.variants?.outline?.(props) ?? {}

  return merge({}, defaultStyles, {
    field: {
      background: "white",
    },
  })
})

export const Input = defineMultiStyleConfig({
  parts: ["field", "addon"],
  baseStyle: {
    field: {
      borderRadius: "lg",
      _placeholder: {
        color: "neutrals.600",
        opacity: 1, // Normalize across browsers
      },
    },
  },
  sizes: {
    xl: {
      field: {
        height: "3.5rem",
      },
    },
    lg: {
      field: {
        height: "3rem",
      },
    },
  },
  variants: {
    outline: variantOutline,
  },
  defaultProps: {
    variant: "outline",
    // @ts-expect-error Chakra's theme typings are not correctly inferred
    focusBorderColor: "main.700",
  },
})
